import { connect } from 'react-redux';
import { toggleModal, toggleSnackBar } from 'state/callers';

import { dispatchify } from 'common/utils/utils';
import { createTeam, getTeams } from 'state/callers/teams';
import { individualContributorsSelector } from 'state/selectors/contributors';
import { isTeamLicenseSelector } from 'state/selectors/license';
import { isVPModeSelector } from 'state/selectors/ui-state';
import Contributors from './Contributors';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => {
  const { currentTeams } = state;
  return {
    contributors: individualContributorsSelector(state),
    isVPMode: isVPModeSelector(state),
    currentTeams,
    isTeamLicense: isTeamLicenseSelector(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...dispatchify(dispatch, {
      toggleModal,
      toggleSnackBar,
      createTeam,
      getTeams
    })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Contributors, 'People'));
